import { BaseIcons, KeyOfIcons } from "lib/icons"

export enum ContentTypes {
  IMAGE = 'IMAGE',
  FILE = 'FILE',
  VIDEO = 'VIDEO'
}

export const embeddableImageContentTypes = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/gif'
];

export const embeddableVideoContentTypes = [
  'video/mp4'
];

export const embeddableContentTypes = [...embeddableImageContentTypes, ...embeddableVideoContentTypes];

export const contentTypeToIconMap = {
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': BaseIcons.Doc,
  'application/vnd.oasis.opendocument.text': BaseIcons.Doc,
  'application/msword': BaseIcons.Doc,
  'application/postscript': BaseIcons.Eps,
  'application/eps': BaseIcons.Eps,
  'application/x-eps': BaseIcons.Eps,
  'image/eps': BaseIcons.Eps,
  'image/x-eps': BaseIcons.Eps,
  'text/html': BaseIcons.Html,
  'application/pdf': BaseIcons.Pdf,
  'image/vnd.adobe.photoshop': BaseIcons.Photoshop,
  'application/vnd.ms-powerpoint': BaseIcons.Ppt,
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': BaseIcons.Ppt,
  'application/vnd.oasis.opendocument.presentation': BaseIcons.Slidedeck,
  'application/vnd.oasis.opendocument.spreadsheet': BaseIcons.Spreadsheet,
  'application/vnd.ms-excel': BaseIcons.Spreadsheet,
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': BaseIcons.Spreadsheet,
  'text/plain': BaseIcons.Txt,
  'application/zip': BaseIcons.Zip,
}

export const lookupFileIconName = (contentType: string, ext: string): KeyOfIcons => {
  if (contentTypeToIconMap[contentType]) {
    const icon = contentTypeToIconMap[contentType];

    if (ext === 'ai') {
      if (icon === BaseIcons.Pdf || icon === BaseIcons.Eps) {
        return BaseIcons.Illustrator;
      }
    }

    return icon;
  }
  
  if (contentType.startsWith('video/')) {
    return BaseIcons.Video;
  }
  
  if (contentType.startsWith('image/')) {
    return BaseIcons.Image;
  }
  
  if (contentType.startsWith('audio/')) {
    return BaseIcons.Audio;
  }
    
  return BaseIcons.File;
}
